<template>
  <div class="quote">
    <div class="custom_sku">
      <div class="label" v-if="headline">
        <h5>{{ headline }}</h5>
      </div>
      <div class="sku">
        <span class="built_in">{{ product.family }}</span>
        <span class="built_in">{{ product.model }}</span>
        <span class="built_in">{{ product.type }}</span>
        <span class="option" v-for="(step, index) in product.steps" :key="step.title">
          <span class="value">{{ skuSelection(step) }}</span>
          <span class="number" v-if="!simplified"><i>{{ index + 1 }}</i></span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    simplified: {},
    product: {},
    selections: {},
    headline: {
      default: "Your Custom Sku"
    }
  },
  methods: {
    skuSelection(step) {
      if (this.selections[step.id] && this.selections[step.id].external) {
        return this.selections[step.id].external;
      } else {
        return '???';
      }
    }
  },
}
</script>
